
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"74","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.632 14.1a1.289 1.289 0 00-.866.365L11.94 36.485c-.462.236-.94 1.203-.94 1.907v31.684h20.876V55.98h9.267v14.08H62v-31.7c0-.703-.477-1.67-.94-1.907l-11.806-11.01-12.238-11.296h-.07a.876.876 0 00-.29-.07l-.024.023z","fill":"#413E3E"}}),_c('path',{attrs:{"d":"M36.395 3.076a1.145 1.145 0 00-.802.357L17.961 19.896.33 36.359c-.463.23-.478.717.218.717h4.645c.696 0 1.638-.487 2.104-.717l14.256-13.027 14.255-13.026a1.168 1.168 0 01.835-.346 1.181 1.181 0 01.834.346l14.15 12.919 14.151 12.919c.463.23 1.408.717 2.105.717h4.64c.467 0 .685-.26.218-.717L55.001 19.788 37.262 3.433a1.308 1.308 0 00-.867-.357z","fill":"#00BECC"}})])
          )
        }
      }
    